import React from 'react';
import { pure, compose, withHandlers, lifecycle } from 'recompose';

interface TypeformEmbedProps {
  autoOpen?: boolean;
  url: string;
  hideHeaders?: boolean;
  hideFooter?: boolean;
  onRef?: (ref: any) => any;
}

const TypeformEmbed = ({}: TypeformEmbedProps) => <div />;

export default compose(
  withHandlers(({ url, onRef, autoOpen, hideHeaders, hideFooter }) => {
    let script;
    let ref;

    const setupForm = () => {
      // Get the URL params to track Typeform source
      const urlParams = new URLSearchParams(window.location.search);
      const utmSource = urlParams.has('utm_source')
        ? `utm_source=${urlParams.get('utm_source')}&`
        : '';
      const utmMedium = urlParams.has('utm_medium')
        ? `utm_medium=${urlParams.get('utm_medium')}&`
        : '';
      const utmCampaign = urlParams.has('utm_campaign')
        ? `utm_campaign=${urlParams.get('utm_campaign')}&`
        : '';
      const utmContent = urlParams.has('utm_content')
        ? `utm_content=${urlParams.get('utm_content')}&`
        : '';
      let typeformURL = url;
      if (utmSource || utmMedium || utmCampaign || utmContent) {
        typeformURL = `${url}#${utmSource}${utmMedium}${utmCampaign}${utmContent}`;
      }

      ref = window['typeformEmbed'].makePopup(typeformURL, {
        autoOpen,
        hideHeaders,
        hideFooter,
      });

      if (onRef) onRef(ref);
    };

    return {
      onMount: () => () => {
        if (typeof window['typeformEmbed'] !== 'undefined') return setupForm();
        script = document.createElement('script');
        script.src = '//embed.typeform.com/embed.js';
        script.onload = setupForm;

        document.body.appendChild(script);
      },

      onUnmount: () => () => {
        if (script) document.body.removeChild(script);
        if (ref) ref.close();
      },
    };
  }),
  lifecycle({
    componentDidMount() {
      (this.props as any).onMount();
    },

    componentWillUnmount() {
      (this.props as any).onUnmount();
    },
  }),
  pure
)(TypeformEmbed);
